export default __webpack_public_path__ + "static/media/maria-chiara-carrozza.6f5d6a0c.png";